import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, Center, Spinner } from "@chakra-ui/react";
import { Panel, EmptyState } from "../ui";
import { useAuth } from "../../contexts/AuthContext";

// Gates the in-dashboard storefront routes (shop / product / cart / checkout) on
// shop access. Unlike the marketing ShopRoute (which shows a full-page pending
// screen), this renders inside the dashboard shell, so it shows a dashboard-
// styled empty state pointing at enrollment. Admins have shop access implicitly.
const ShopGate = ({ children }) => {
  const navigate = useNavigate();
  const { session, loading, profileLoading, shopAccess } = useAuth();

  if (loading || (session && profileLoading)) {
    return (
      <Center py={20}>
        <Spinner color="maroon.800" />
      </Center>
    );
  }

  if (!shopAccess) {
    return (
      <Box p={{ base: 4, md: 8 }} w="full" maxW="760px" mx="auto">
        <Panel bodyProps={{ p: 0 }}>
          <EmptyState
            icon="storefront"
            title="Shop access pending"
            subtitle="The BIO-PLY™ shop is available to approved veterinary practices. Complete enrollment or wait for approval to place orders."
            action={
              <Button
                variant="primary"
                onClick={() => navigate("/dashboard")}
              >
                Back to dashboard
              </Button>
            }
          />
        </Panel>
      </Box>
    );
  }

  return children;
};

export default ShopGate;
